import logo from "../images/Logo.png";
import logoBlue from "../images/12.png";
import {
    FaFacebook,
    FaTwitter,
    FaInstagram,
    FaLinkedinIn,
    FaHome,
    FaInfoCircle,
    FaWrench,
    FaPhoneAlt,
    FaLevelUpAlt,
} from 'react-icons/fa';
import { FaArrowUp, FaLinkedin, FaUpDown } from "react-icons/fa6";
import { RxCross2 } from 'react-icons/rx';
import { ToastContainer, Bounce } from 'react-toastify';
import { useEffect, useState } from "react";

const Footer = (props) => {
    const color = props.color;
    const isblue = props.isblue;
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setVisible(window.scrollY > 300);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    return (
        <div>
            <footer className={`${isblue ? "background-with-image-blue" : "bg-[#edebe6]"} text-white py-6 md:py-12 hidden md:block`}>
                <div className="mx-auto px-16 md:flex justify-start space-y-12 md:space-y-0 md:space-x-24">
                    {/* Logo and Social Icons */}
                    <div className="flex flex-col items-start md:items-center">
                        <div className="text-center">
                            <img
                                src={isblue ? logo : logoBlue}
                                alt="Logo"
                                className="w-[120px] mb-4 object-contain"
                            />
                        </div>

                        <div className={`${isblue ? "text-white" : "text-[#80a2a5]"} flex space-x-6 text-xl mt-0`}>
                            <a href="https://www.facebook.com/share/17obGDuRuX" target='_blank' aria-label="Facebook" className="hover:text-gray-300">
                                <FaFacebook />
                            </a>
                            <a href="https://www.instagram.com/iramkhokher.lifecoach" target='_blank' aria-label="Instagram" className="hover:text-gray-300">
                                <FaInstagram />
                            </a>
                            <a href="https://www.linkedin.com/in/iram-khokher-coach-for-high-achieviers" target='_blank' aria-label="LinkedIn" className="hover:text-gray-300">
                                <FaLinkedin />
                            </a>
                        </div>
                    </div>

                    {/* Navigation Links */}
                    <div className={`${isblue ? "text-white" : "text-[#80a2a5]"} poppins text-sm pt-4`}>
                        {/* Site Map */}
                        <div>
                            <ul className="space-y-4">
                                <li className="flex items-start md:items-center space-x-3 cursor-pointer">
                                    {/* <FaHome /> */}
                                    <a href="/">HOME</a>
                                </li>
                                <li className="flex items-center space-x-3 cursor-pointer">
                                    {/* <FaInfoCircle /> */}
                                    <a href="/About">ABOUT</a>
                                </li>
                                <li className="flex items-center space-x-3 cursor-pointer">
                                    {/* <FaWrench /> */}
                                    <a href="/Services">VIP SERVICES</a>
                                </li>
                                <li className="flex items-center space-x-3 cursor-pointer">
                                    {/* <FaPhoneAlt /> */}
                                    <a href="/Contact">CONTACT US</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
            <footer className={`text-${color == "blue" ? "white" : "[#80a2a5]"} py-6 md:py-12 ${color == "blue" ? "background-with-image-blue" : "bg-[#edebe6]"} block md:hidden fixed bottom-0 left-0 w-full z-50`}>
                <div className="grid grid-cols-3 px-4 ">
                    <div className="text-center cursor-pointer">
                        <a href="/Services" className={`text-md transition duration-300 ease-in-out  pb-2 border-transparent border-b-2 font-normal poppins `}>
                            VIP SERVICES
                        </a>
                    </div>
                    <div className="text-center cursor-pointer">
                        <a href="/About" className={`text-md transition duration-300 ease-in-out   pb-2 border-transparent border-b-2  font-normal poppins `}>
                            ABOUT
                        </a>
                    </div>
                    <div className="text-center cursor-pointer">
                        <a href="/Contact" className={`text-md transition duration-300 ease-in-out   pb-2 border-transparent border-b-2 font-normal poppins `}>
                            CONTACT US
                        </a>
                    </div>
                </div>

                <div className="text-center cursor-pointer mt-6">
                    <a href="/Rewire" className={`uppercase px-4 rounded-full text-md transition delay-50 duration-300 ease-in-out text-white  py-1  border-2 border-[#f15d16] bg-[#f15d16] font-normal mb-2 poppins `}>
                        rewire now
                    </a>
                </div>
            </footer>
            <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
                transition={Bounce}
            />
            <button
                onClick={scrollToTop}
                className={`
        fixed bottom-32 md:bottom-5 right-2 md:right-5 z-50
        flex items-center justify-center
        h-11 w-11 rounded
        bg-gray-800 text-white
        shadow-lg
        hover:bg-gray-700
        transition-all duration-300 background-with-image
         ${visible
                        ? "opacity-100 translate-y-0 pointer-events-auto"
                        : "opacity-0 translate-y-4 pointer-events-none"
                    }
      `}
                aria-label="Back to top"
            >
                <FaArrowUp />
            </button>
        </div>
    );
};

export default Footer;
